import React from "react";
import { CheckboxButton } from "../../shared/CheckboxButton/CheckboxButton";
import { Icon } from "../../shared/Icon/Icon";

interface Member {
  id: string;
  name: string;
  email: string;
  role?: string;
}

interface MembersListProps {
  members: Member[];
  mode: "view" | "add";
  selectedMembers?: Set<string>;
  onMemberToggle?: (memberId: string) => void;
  onMemberRemove?: (memberId: string) => void;
  className?: string;
}

export const MembersList = ({
  members,
  mode,
  selectedMembers = new Set(),
  onMemberToggle,
  onMemberRemove,
  className = "",
}: MembersListProps) => {
  return (
    <div className={`MembersModal__users ${className}`}>
      <div className="flex-a-center MembersModal__user MembersModal__users--header">
        {mode === "add" && <div style={{ width: "24px" }}></div>}
        <span className="MembersModal__user--name">Name</span>
        <span className="MembersModal__user--email">Email</span>
        {mode === "view" && <div style={{ width: "16px" }}></div>}
      </div>

      {members.map((member) => (
        <div key={member.id} className="flex-a-center MembersModal__user">
          {mode === "add" && onMemberToggle && (
            <CheckboxButton
              checked={selectedMembers.has(member.id)}
              onChange={() => onMemberToggle(member.id)}
              hideLabel
              id={`member-${member.id}`}
              name={`member-${member.id}`}
              className="MembersModal__user--checkbox"
            />
          )}

          <span className="MembersModal__user--name" title={member.name}>
            {member.name}
          </span>
          <span className="MembersModal__user--email" title={member.email}>
            {member.email}
          </span>

          {mode === "view" && onMemberRemove && (
            <Icon
              icon="delete-icon"
              className="MembersModal__user--delete"
              onClick={() => onMemberRemove(member.id)}
            />
          )}
        </div>
      ))}
    </div>
  );
};
